import {
  ContainerSummary,
  GridSummary,
  PlateSummaryExtras,
  StorableSummaryExtras,
} from 'constants/SampleConstants';
import * as net from 'util/Net';

interface ListingParams {
  offset: number;
  limit: number;
  includeStorableSummaryExtras?: boolean;
  archivePurposes?: Array<string>;
}

export interface ListContainersResponse {
  containers: Array<ContainerSummary>;
  total: number;
  totalWithHidden: number;
  storableSummaryExtras: StorableSummaryExtras;
}

export function listContainers(
  containableId: string,
  {offset, limit, includeStorableSummaryExtras, archivePurposes}: ListingParams
): JQueryPromise<ListContainersResponse> {
  return net.postJSON({
    url: `/1/api/containables/${containableId}/containers`,
    data: {
      archivePurposes,
      includeStorableSummaryExtras,
      offset,
      limit,
    },
  });
}

export interface ListPlatesResponse {
  plates: Array<GridSummary>;
  total: number;
  totalWithHidden: number;
  plateSummaryExtras: PlateSummaryExtras;
  storableSummaryExtras: StorableSummaryExtras;
}

export function listPlates(
  containableId: string,
  {offset, limit, includeStorableSummaryExtras, archivePurposes}: ListingParams
): JQueryPromise<ListPlatesResponse> {
  return net.postJSON({
    url: `/1/api/containables/${containableId}/plates`,
    data: {
      archivePurposes,
      includeStorableSummaryExtras,
      offset,
      limit,
    },
  });
}
